<template>
  <div>
    <b-row>
      <b-col cols="6"> <b-button @click="$router.push('/cms/collections')">Zurück</b-button> </b-col>
    
    </b-row>
    <b-row>
      <b-col cols="12">
        <h2 id="navigation-title">Gelöschte Data-Collection ({{ defItem.title }})</h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-row>

          <b-col cols="12">
            <div v-if="currentCollection == 1" class="mb-3">
              <b-form-input v-model="catalogSearch" :debounce="350" placeholder="Formularname oder ID suchen" @update="loadCatalogPage(1)" />
              <b-pagination :value="catalogPage" :total-rows="catalogTotal" :per-page="catalogPageSize" @change="loadCatalogPage" class="mt-2" />
              <small>{{ catalogTotal }} Formulare</small>
              <b-alert :show="catalogError" variant="danger">Formularliste konnte nicht geladen werden.</b-alert>
            </div>
            <b-table :fields="fields" :items="items" :class="'collectionTable' + currentTableKey">
              <template #cell()="data">
                <span v-if="data.field.type == 'Formio'">
                  <b-button :href="'/cms/formBuilder/item/' +
                    data.item.collectionValueId +
                    '/' +
                    data.field.key.replace('value.', '')
                    " class="ozg-button small simple" target="_blank">
                    Konfigurieren
                    <small><b-icon-pencil></b-icon-pencil></small>
                  </b-button>
                </span>

                <span v-else-if="data.field.type == 'BPM'">
                  <b-button :href="'/cms/bpmBuilder/item/' +
                    data.item.collectionValueId
                    " class="ozg-button small simple" target="_blank">
                    BPMN
                    <small><b-icon-pencil></b-icon-pencil></small>
                  </b-button>
                </span>

                <span v-else-if="data.field.type == 'revisionCount'">
                  <b-button variant="primary" @click="showRevisions(data.item)">

                    {{ data.item.revisionCount }}

                  </b-button>
                </span>
                <span v-else-if="data.field.type == 'MailEditor'">
                  <b-button :href="'/cms/mailBuilder/item/' +
                    data.item.collectionValueId +
                    '/' +
                    data.field.key.replace('value.', '')
                    " class="ozg-button small simple" target="_blank">
                    Konfigurierenf
                    <small><b-icon-pencil></b-icon-pencil></small>
                  </b-button>
                </span>
                <span v-else>
                  <span v-if="data.field.type != undefined &&
                    data.field.type.includes('foreign')
                    ">

                    <span v-if="data != null && data != undefined && data.field.type == 'foreignMultiSelect' &&
                      data.value != null &&
                      data.value != undefined &&
                      data.value != ''
                      ">
                      {{
                        data.value
                          .map((e) => e[data.field.foreignText])
                          .join(", ")
                      }}
                    </span>

                    <span v-if="data != null && data != undefined && data != '' &&
                        data.field.type == 'foreignMultiSelectWithMax' &&
                        data.value != null &&
                        data.value != undefined &&
                        data.value != ''
                        ">
                      {{
                        data.value
                          .map((e) => e[data.field.foreignText])
                          .join(", ")
                      }}
                    </span>


                    <span v-if="data.field.type == 'foreignSingleSelect'">
                      {{
                        data.item.value[data.field.foreignValue][
                        data.field.foreignText
                        ]
                      }}
                    </span>
                    <span v-else>
                      {{ data.value.text }}
                    </span>
                  </span>
                  <span v-else>
                    {{ data.value }}
                  </span>
                </span>
              </template>
              <template v-slot:cell(actions)="{ item }">
                <div style="width: 65px">
                  <b-icon-reply-all style="margin-right: 10px; cursor: pointer" font-scale="1" v-b-tooltip.hover
                    title=" bearbeiten" @click="saveData(item)"></b-icon-reply-all>

                
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import config from "@/config/config.js";
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      fields: [],
      items: [],
      catalogPage: 1,
      catalogPageSize: 25,
      catalogTotal: 0,
      catalogSearch: "",
      catalogError: false,
      catalogRequestId: 0,
      currentCollection: 1,
      defItem: {},
      currentTableKey: 1,
    };
  },

  mounted() {
    this.currentCollection = this.$route.params.id;
    this.currentTableKey = moment().format("X");

    this.initializeCollection();
  },

  methods: {
    loadCatalogPage(page) {
      this.catalogPage = page;
      this.initializeCollection();
    },
    async loadFullCatalogItem(item) {
      if (this.currentCollection != 1) return item;
      const response = await axios.get(config.API_URL + "/api/form/" + item.collectionValueId);
      return { ...item, ...response.data, collectionValueId: item.collectionValueId, value: JSON.parse(response.data.value) };
    },
    initializeCollection() {
      let self = this;
      const requestId = ++self.catalogRequestId;
      self.catalogError = false;
      axios
        .get(config.API_URL + "/api/CollectionDef/" + self.currentCollection)
        .then((responseValue) => {
          if (requestId !== self.catalogRequestId) return;
          self.defItem = responseValue.data;
          let url = "collectionTrashed";
          if (self.currentCollection == 1) {
            url = "collectionForFormsMetadata";
          }
          axios
            .get(config.API_URL + "/api/" + url + "/" + self.currentCollection, {
              params: self.currentCollection == 1 ? {
                page: self.catalogPage, pageSize: self.catalogPageSize, search: self.catalogSearch,
                deleted: true, includeRevisionCounts: true
              } : {}
            })
            .then((response) => {
              if (requestId !== self.catalogRequestId) return;
              self.fields = [];
              const catalog = JSON.parse(response.data)[0];
              self.catalogTotal = catalog.totalCount || 0;
              let list = [];

              if (JSON.parse(response.data)[0].items != null) {
                list = JSON.parse(response.data)[0].items.map((i, index) => ({
                  collectionValueId: i.collectionValueId,
                  value: JSON.parse(i.value),
                  fullItems:i.fullItems,
                  hidden: i.hidden ? i.hidden : false,
                  showFrom: i.showFrom ? i.showFrom : null,
                  showUntil: i.showUntil ? i.showUntil : null,
                  restrictionGroups: i.restrictionGroups
                    ? JSON.parse(i.restrictionGroups)
                    : null,
                  created_at: i.created_at ? i.created_at : null,
                  deleted_at: i.deleted_at ? i.deleted_at : null,

                  sortOrder: i.sortOrder != null ? i.sortOrder : index,
                  revisionCount: i.revisionCount != null ? i.revisionCount : 0,
                  ChangeUser: i.ChangeUser != null ? i.ChangeUser : ""
                }));
              }

             
              let fields = JSON.parse(
                JSON.parse(response.data)[0].fields
              ).fields.filter((f) => f.isOverview);

              if (fields == null || fields.length == 0) {
                fields = JSON.parse(JSON.parse(response.data)[0].fields).fields;
              }

              self.fields.push({
                key: "collectionValueId",
                title: "#",
                type: "actions",
              });
              fields.forEach(function (field) {
                field.key = "value." + field.key;
                field.label = field.title;
                field.type = field.type;
                self.fields.push(field);
              });

              self.fields.push({
                key: "deleted_at",
                label: "Gelöscht am",
              });

              self.fields.push({
                key: "ChangeUser",
                label: "Letzte Änderung durch",
              });
              self.fields.push({
                key: "revisionCount",
                title: "Revisionen",
                type: "revisionCount",
              });
              self.fields.push({
                key: "actions",
                title: "Aktionen",
                type: "actions",
              });

              self.items = list;
              if (self.currentCollection == 1) return;
              $(document).ready(function () {
                setTimeout(function () {
                  $(".collectionTable" + self.currentTableKey).DataTable({
                    retrieve: true,



                    language: {
                      url: "https://cdn.datatables.net/plug-ins/2.0.8/i18n/de-DE.json",
                    },
                  });
                }, 300);
              });
            }).catch(() => { if (requestId === self.catalogRequestId) self.catalogError = true; });
        }).catch(() => { if (requestId === self.catalogRequestId) self.catalogError = true; });
    },

    openCrud() {
      let self = this;
      this.$root.$children[0].showBaseModal = true;

      this.$root.$children[0].baseDialogComponentName = "DynamicCrudDialog";
      this.$root.$children[0].baseDialogData = {};
      this.$root.$children[0].baseDialogData.item = {};
      this.$root.$children[0].baseDialogData.foreignKeyValue =
        self.defItem.collectionId;
      this.$root.$children[0].baseDialogData.fields = self.defItem.definition;
      this.$root.$children[0].baseDialogData.formioFormId = self.defItem.formFormId
      this.$root.$children[0].baseDialogData.saveFunction = function () {
        self.saveData(self.$root.$children[0].baseDialogData.item);
      };
      this.$root.$children[0].baseDialogData.item.OrgSaveFunction =
        this.$root.$children[0].baseDialogData.saveFunction;
      this.$root.$children[0].dialogTitle = "Datensatz hinzufügen"
      this.$root.$children[0].baseDialogData.Key = moment().format("X");
    },

    
    async deleteCollectionItem(item) {
      try { item = await this.loadFullCatalogItem(item); }
      catch (error) { this.catalogError = true; return; }
      let self = this;
      let editItem = { id: item.collectionValueId, value: item.value };

      self.$root.$children[0].deleteCollectionItem(editItem, function () {
        self.initializeCollection();
      });
    },

    async copyCollectionItem(item) {
      try { item = await this.loadFullCatalogItem(item); }
      catch (error) { this.catalogError = true; return; }
      let self = this;

      self.$root.$children[0].copyCollectionItem(item, function () {
        self.initializeCollection();
      });
    },
    saveData(item) {
      let self = this;
      item.collectionId = self.defItem.collectionId;
      item.deleted = false;
      item.value = JSON.stringify(item);

      if (
        item.collectionValueId != null &&
        item.collectionValueId != undefined &&
        item.collectionValueId != -1
      ) {
        axios
          .put(
            config.API_URL + "/api/collectionItem/" + item.collectionValueId,
            item
          )
          .then((response) => {
            item.collectionValueId = response.data.collectionValueId;
            self.$root.$children[0].showBaseModal = false;
            self.$root.$children[0].afterSaveFunctionAction(item);

            self.initializeCollection();
          });
      } else {
        axios
          .post(config.API_URL + "/api/collectionItem/", item)
          .then((response) => {
            self.$root.$children[0].showBaseModal = false;
            item.collectionValueId = response.data.collectionValueId;
            self.$root.$children[0].afterSaveFunctionAction(item);

            self.initializeCollection();
          });
      }
    },

    showRevisions(item) {
      let self = this;


      let query = {};
      query.query = "usf_RevisionForTable('collectionValue'," + item.collectionValueId + ")";
      axios
        .post(config.API_URL + "/api/dynamicQuery/", query)
        .then((response) => {
          self.$root.$children[0].showBaseModal = true;

          self.$root.$children[0].baseDialogComponentName = "JSONEditorDialog";
          self.$root.$children[0].baseDialogData = {};
          self.$root.$children[0].baseDialogData.canSave = false;


          let itemCopy = JSON.parse(response.data);

          itemCopy = itemCopy.map((e) => ({
            changeDate: e.created_at,
            changeUser: e.ChangeUser,
            old_value: JSON.parse(e.old_value),
            new_value: JSON.parse(e.new_value),
          }));

          self.$root.$children[0].baseDialogData.json = itemCopy;

          self.$root.$children[0].baseDialogData.Key = moment().format("X");
          self.showLoadingOverlay = false;
        });
      /*loadRevivsiosn*/

    },
  },
};
</script>
